import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalBody,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModalTitle,
  CModalFooter,
  CButton,
  CSpinner,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import Uploader from "../Uploader/uploader";

import "./css/content.css";

class UploadCreator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // description: "",
      loading: true,
      docs: [],
      doc_id: null,
      tab: 1,
      file: null,
      name: null
    };
  }

  componentDidMount() {
    axios
      .post(
        `${URL.api}content/doc/list`,
        { user_id: this.props.user.user.id, shared: false },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ docs: resp.data.data, loading: false });
        },
        error => {
          this.error("Não foi possível listar os documentos!");
        }
      );
  }

  insert() {
    if (this.state.tab === 0) {
      const doc = this.state.docs.find(doc => doc.id === this.state.selected);

      if (doc && !doc.folder) {
        this.props.doneArchive(doc.link, doc.name);
      }
    } else if (this.state.file) {
      this.props.doneArchive(this.state.file, this.state.name);
    }

    this.props.onClose();
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        size="xl"
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CDropdown className="d-inline-block">
            <CDropdownToggle color="white" className="p-0">
              <CModalTitle className="d-inline-block mr-1">
                {this.state.tab === 0 ? "Meus documentos" : "Fazer upload"}
              </CModalTitle>
            </CDropdownToggle>
            <CDropdownMenu
              placement="bottom"
              modifiers={[{ name: "flip", enabled: false }]}
            >
              <CDropdownItem onClick={() => this.setState({ tab: 0 })}>
                Meus documentos
              </CDropdownItem>
              <CDropdownItem onClick={() => this.setState({ tab: 1 })}>
                Fazer upload
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CModalHeader>
        <CModalBody className="pb-0">
          {this.state.tab === 0 ? (
            <>
              {this.state.loading ? (
                <div className="pt-2 pb-3">
                  <Loading />
                </div>
              ) : this.state.docs && this.state.docs.length > 0 ? (
                <>
                  <CRow>
                    {this.state.doc_id !== null && (
                      <CCol md={3} sm={4}>
                        <CCard
                          className={
                            this.state.selected === -1 && "doc-selected"
                          }
                          onClick={() => this.setState({ selected: -1 })}
                          onDoubleClick={() =>
                            this.setState({
                              // eslint-disable-next-line react/no-access-state-in-setstate
                              doc_id: this.state.docs.find(
                                // eslint-disable-next-line react/no-access-state-in-setstate
                                item => item.id === this.state.doc_id
                              ).doc_id
                            })
                          }
                        >
                          <CCardBody
                            style={{
                              pointerEvents: "none",
                              userSelect: "none"
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <i className="fa fa-folder-open text-muted"></i>
                              <span
                                className="text-ellipsis mx-3"
                                style={{ flex: 1 }}
                              >
                                ..
                              </span>
                            </div>
                          </CCardBody>
                        </CCard>
                      </CCol>
                    )}
                    {this.state.docs &&
                      this.state.docs
                        .filter(
                          doc =>
                            doc.folder === true &&
                            doc.doc_id === this.state.doc_id
                        )
                        .map(doc => (
                          <CCol md={3} sm={4}>
                            <CCard
                              className={
                                this.state.selected === doc.id && "doc-selected"
                              }
                              onClick={() =>
                                this.setState({ selected: doc.id })
                              }
                              onDoubleClick={() =>
                                this.setState({ doc_id: doc.id })
                              }
                            >
                              <CCardBody
                                style={{
                                  pointerEvents: "none",
                                  userSelect: "none"
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-folder text-muted"></i>
                                  <span
                                    className="text-ellipsis mx-3"
                                    style={{ flex: 1 }}
                                  >
                                    {doc.name}
                                  </span>
                                  <span className="text-muted">
                                    {
                                      this.state.docs.filter(
                                        item => item.doc_id === doc.id
                                      ).length
                                    }
                                  </span>
                                </div>
                              </CCardBody>
                            </CCard>
                          </CCol>
                        ))}
                  </CRow>
                  <CRow>
                    {this.state.docs &&
                      this.state.docs
                        .filter(
                          doc =>
                            doc.folder === false &&
                            doc.doc_id === this.state.doc_id
                        )
                        .map(doc => (
                          <CCol md={2} sm={3}>
                            <CCard
                              className={
                                this.state.selected === doc.id && "doc-selected"
                              }
                              onClick={() =>
                                this.setState({ selected: doc.id })
                              }
                            >
                              <CCardHeader
                                className="p-0 d-flex justify-content-center align-items-center"
                                style={{
                                  pointerEvents: "none",
                                  userSelect: "none"
                                }}
                              >
                                <i
                                  className="fa fa-file text-danger m-0"
                                  style={{ fontSize: "1.25rem" }}
                                ></i>
                                <div style={{ paddingBottom: "56.25%" }}></div>
                              </CCardHeader>
                              <CCardBody
                                style={{
                                  pointerEvents: "none",
                                  userSelect: "none"
                                }}
                              >
                                <div className="text-ellipsis text-center">
                                  {doc.name}
                                </div>
                              </CCardBody>
                            </CCard>
                          </CCol>
                        ))}
                  </CRow>
                </>
              ) : (
                <div className="d-flex align-items-center justify-content-center m-3">
                  Nenhum documento encontrado
                </div>
              )}
            </>
          ) : (
            <Uploader
              type="activity"
              maxFiles={1}
              allowMultiple
              labelIdle="Clique aqui ou arraste um arquivo para cá"
              done={(uploads, names) =>
                this.setState({ file: uploads[0], name: names[0] })
              }
            />
          )}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            disabled={this.state.loading}
            onClick={() => this.insert()}
          >
            <>
              <span style={this.state.loading ? { opacity: 0 } : null}>
                Inserir
              </span>
              {this.state.loading && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadCreator);
